"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowRouter = void 0;
const escrow_sdk_v0_1 = require("escrow-sdk-v0");
const index_1 = require("../../index");
const types_1 = require("../types");
const utils_1 = require("../utils");
const lodash_1 = require("lodash");
const helpers_1 = require("../utils/helpers");
class EscrowRouter {
    constructor(connection, pubkeyV1, configIdV1, pubkeyV0, configIdV0) {
        this.pubkeyV0 = pubkeyV0;
        this.pubkeyV1 = pubkeyV1;
        this.configIdV0 = configIdV0;
        this.configIdV1 = configIdV1;
        this.marketIdV1 = this.configIdV1; // TODO: hardfix. PROGRAM should remove this field in the next update
        const pdaV1 = new index_1.PDA(this.pubkeyV1, this.marketIdV1, this.configIdV1);
        this.fetcherV1 = new index_1.EscrowFetcher(connection, pdaV1);
        if (this.pubkeyV0 && this.configIdV0) {
            const pdaV0 = new escrow_sdk_v0_1.PDA(this.pubkeyV0, this.configIdV0);
            this.fetcherV0 = new escrow_sdk_v0_1.EscrowFetcher(connection, pdaV0);
        }
    }
    /**
     * @dev get trade by status and side optinally
     * @param tradeStatus : Awaiting | Deposited | Disputed | Released | Canceled
     * @param side  : Buy | Sell (if not provided, will return both buy and sell)
     * @returns ITradeDataInfo[]
     */
    getTradesByStatus(tradeStatus, side) {
        return __awaiter(this, void 0, void 0, function* () {
            let tradesV0 = [];
            // Get trades of v0 version
            if (this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                if (side) {
                    tradesV0 = yield this.fetcherV0.getTradesByStatus(tradeStatus, side);
                }
                else {
                    tradesV0 = yield this.fetcherV0.getTradesByStatus(tradeStatus);
                }
            }
            // Get trades of v1 version
            yield this.fetcherV1.refreshAll();
            let tradesV1 = [];
            if (side) {
                tradesV1 = yield this.fetcherV1.getTradesByStatus(tradeStatus, side);
            }
            else {
                tradesV1 = yield this.fetcherV1.getTradesByStatus(tradeStatus);
            }
            return [...(0, utils_1.convertTradesV0)(tradesV0), ...(0, utils_1.convertTradesV1)(tradesV1)];
        });
    }
    getOffersByStatus(offerStatus, side) {
        return __awaiter(this, void 0, void 0, function* () {
            // Get offer v0
            let offersV0 = [];
            if (this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                if (side) {
                    offersV0 = yield this.fetcherV0.getOffersByStatus(offerStatus, side);
                }
                else {
                    offersV0 = yield this.fetcherV0.getOffersByStatus(offerStatus);
                }
            }
            // Get offer v1
            yield this.fetcherV1.refreshAll();
            let offersV1 = [];
            if (side) {
                offersV1 = yield this.fetcherV1.getOffersByStatus(offerStatus, side);
            }
            else {
                offersV1 = yield this.fetcherV1.getOffersByStatus(offerStatus);
            }
            return [...(0, utils_1.convertOffersV0)(offersV0), ...(0, utils_1.convertOffersV1)(offersV1)];
        });
    }
    getTradesByBuyerAddress(buyerAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredTradesV0 = [];
            // Get trade v0
            if (this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                const tradesV0 = yield this.fetcherV0.getTradesByBuyerAddress(buyerAddress);
                filteredTradesV0 = tradesV0.filter((trade) => trade !== null);
            }
            // Get trade v1
            yield this.fetcherV1.refreshAll();
            const tradesV1 = yield this.fetcherV1.getTradesByBuyerAddress(buyerAddress);
            return [...(0, utils_1.convertTradesV0)(filteredTradesV0), ...(0, utils_1.convertTradesV1)(tradesV1)];
        });
    }
    getTradesBySellerAddress(sellerAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredOldTrades = [];
            if (this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                const tradesV0 = yield this.fetcherV0.getTradesBySellerAddress(sellerAddress);
                filteredOldTrades = tradesV0.filter((trade) => trade !== null);
            }
            yield this.fetcherV1.refreshAll();
            const tradesV1 = yield this.fetcherV1.getTradesBySellerAddress(sellerAddress);
            return [...(0, utils_1.convertTradesV0)(filteredOldTrades), ...(0, utils_1.convertTradesV1)(tradesV1)];
        });
    }
    /**
     * a function to get trade data by trade id
     */
    getTradeDataByID(tradeId, version, refresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let tradeVersion = (0, helpers_1.getVersionFromOfferId)(tradeId, version);
            if ((0, lodash_1.isEqual)(tradeVersion, types_1.Version.V0) && this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                const tradeV0 = yield this.fetcherV0.getTradeInfo(tradeId);
                if (!tradeV0)
                    return null;
                return (0, utils_1.convertTradesV0)([tradeV0])[0];
            }
            else if ((0, lodash_1.isEqual)(tradeVersion, types_1.Version.V1)) {
                yield this.fetcherV1.refreshAll();
                const tradeV1 = yield this.fetcherV1.getTradeInfo(tradeId, refresh);
                if (!tradeV1)
                    return null;
                return (0, utils_1.convertTradesV1)([tradeV1])[0];
            }
            else {
                throw new Error("Version not support");
            }
        });
    }
    getTrades(startTradeIdV0, startTradeIdV1) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let tradesV0 = yield ((_a = this.fetcherV0) === null || _a === void 0 ? void 0 : _a.getTrades(startTradeIdV0.toNumber()));
            let tradesV1 = yield this.fetcherV1.getTrades(startTradeIdV1.toNumber());
            let tradesV0Filtered = tradesV0 === null || tradesV0 === void 0 ? void 0 : tradesV0.filter((trade) => trade !== null);
            if (!tradesV0Filtered) {
                tradesV0Filtered = [];
            }
            let tradesV1Filtered = tradesV1.filter((trade) => trade !== null);
            return [...(0, utils_1.convertTradesV0)(tradesV0Filtered), ...(0, utils_1.convertTradesV1)(tradesV1Filtered)];
        });
    }
    /**
     * a function to get offer data by offer id
     */
    getOfferDataByID(offerId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            let offerVersion = (0, helpers_1.getVersionFromOfferId)(offerId, version);
            console.log("----> VERSION: ", offerVersion);
            if ((0, lodash_1.isEqual)(offerVersion, types_1.Version.V0) && this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                const offerV0 = yield this.fetcherV0.getOffer(offerId);
                if (!offerV0)
                    return null;
                return (0, utils_1.convertOffersV0)([offerV0])[0];
            }
            else if ((0, lodash_1.isEqual)(offerVersion, types_1.Version.V1)) {
                yield this.fetcherV1.refreshAll();
                const offerV1 = yield this.fetcherV1.getOffer(offerId);
                if (!offerV1)
                    return null;
                return (0, utils_1.convertOffersV1)([offerV1])[0];
            }
            else {
                throw new Error("Version not support");
            }
        });
    }
    /**
     * a function to get offer data by offer id
     */
    getTradesByOfferId(offerId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            let offerVersion = (0, helpers_1.getVersionFromOfferId)(offerId, version);
            console.log("----> VERSION: ", offerVersion);
            if ((0, lodash_1.isEqual)(offerVersion, types_1.Version.V0) && this.fetcherV0) {
                yield this.fetcherV0.refreshAll();
                const tradesV0 = yield this.fetcherV0.getAllTradesOfAnOffer(offerId);
                return (0, utils_1.convertTradesV0)(tradesV0);
            }
            else if ((0, lodash_1.isEqual)(offerVersion, types_1.Version.V1)) {
                yield this.fetcherV1.refreshAll();
                const tradesV1 = yield this.fetcherV1.getAllTradesOfAnOffer(offerId);
                return (0, utils_1.convertTradesV1)(tradesV1);
            }
            else {
                throw new Error("Version not support");
            }
        });
    }
    getOffersByMakerAddress(makerAddress, version) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const offerInfosV0 = yield ((_a = this.fetcherV0) === null || _a === void 0 ? void 0 : _a.getOffersByMakerAddress(makerAddress));
            const offerInfosV1 = yield this.fetcherV1.getOffersByMakerAddress(makerAddress);
            if (version === types_1.Version.V0) {
                return (0, utils_1.convertOffersV0)((_b = offerInfosV0 === null || offerInfosV0 === void 0 ? void 0 : offerInfosV0.filter((offer) => offer !== null)) !== null && _b !== void 0 ? _b : []);
            }
            else if (version === types_1.Version.V1) {
                return (0, utils_1.convertOffersV1)((_c = offerInfosV1 === null || offerInfosV1 === void 0 ? void 0 : offerInfosV1.filter((offer) => offer !== null)) !== null && _c !== void 0 ? _c : []);
            }
            else {
                return [
                    ...(0, utils_1.convertOffersV0)((_d = offerInfosV0 === null || offerInfosV0 === void 0 ? void 0 : offerInfosV0.filter((offer) => offer !== null)) !== null && _d !== void 0 ? _d : []),
                    ...(0, utils_1.convertOffersV1)((_e = offerInfosV1 === null || offerInfosV1 === void 0 ? void 0 : offerInfosV1.filter((offer) => offer !== null)) !== null && _e !== void 0 ? _e : []),
                ];
            }
        });
    }
    /**
     * a function to make a new offer
     * @param wallet user wallet
     * @param tokenMint mint of token that user want to create offer with
     * @param bondType type of bond. Can either be Spl or Native. Use "BondType" value from sdk
     * @param minTradeSize minimum size of trade can be created from the offer. Should be between "0.2" and "1"
     * @param tokenAmount total amount of token that user want to create offer with
     * @param fiatAmount equivalent number of fiat amount
     * @returns
     */
    makeOffer(wallet, tokenMint, side, bondType, minTradeSize, tokenAmount, fiatAmount, encryptedBankName, encryptedAccountNumber, encryptedAccountName, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${types_1.Version.V1} --> Make offer`);
            const minTradeSizeU64 = (0, index_1.getMinTradeSize)(minTradeSize);
            return yield index_1.OfferClient.makeOffer((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, side, wallet.publicKey, tokenMint, bondType, minTradeSizeU64, tokenAmount, fiatAmount, encryptedBankName, encryptedAccountNumber, encryptedAccountName, nonce);
        });
    }
    matchingEngine(marketClient, user, tradeAmount, offerQuotes, useBondless) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield marketClient.matchingEngine(user, tradeAmount, offerQuotes, useBondless);
        });
    }
    requestCreateTrade(wallet, offerDataInfo, tradeAmount, useBondless = false) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${offerDataInfo.version} --> Request create trade`);
            if ((0, lodash_1.isEqual)(offerDataInfo.version, types_1.Version.V0)) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Escrow V0 not found");
                }
                const offerClientV0 = (0, utils_1.getOfferClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, offerDataInfo);
                return yield offerClientV0.requestCreateTrade(wallet.publicKey, tradeAmount);
            }
            else if ((0, lodash_1.isEqual)(offerDataInfo.version, types_1.Version.V1)) {
                const marketClient = yield index_1.MarketClient.getMarket((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.configIdV1, this.marketIdV1, offerDataInfo.tokenMint);
                return yield marketClient.requestCreateTrade(offerDataInfo.offerId, wallet.publicKey, tradeAmount, useBondless);
            }
            else {
                throw new Error("Version not support");
            }
        });
    }
    cancelTrade(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${tradeData.version} --> Cancel trade`);
            if (tradeData.version == types_1.Version.V0) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Old escrow config not found");
                }
                const tradeV0 = (0, utils_1.getTradeClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, tradeData);
                return tradeV0.cancelTrade(wallet.publicKey);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeClientV1)((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, tradeData);
                return tradeCurrent.cancelTrade(wallet.publicKey);
            }
        });
    }
    /**
     * @dev can handle both versions
     */
    cancelOffer(wallet, offerData) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${offerData.version} --> Cancel offer`);
            if ((0, lodash_1.isEqual)(offerData.version, types_1.Version.V0)) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Old escrow config not found");
                }
                const offerV0 = (0, utils_1.getOfferClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, offerData);
                return (yield offerV0.cancelOffer()).tx;
            }
            else if ((0, lodash_1.isEqual)(offerData.version, types_1.Version.V1)) {
                const offerV1 = yield (0, utils_1.getOfferClientV1)((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, offerData.offerId);
                return (yield offerV1.cancelOffer()).tx;
            }
            else {
                throw new Error("Version not support");
            }
        });
    }
    release(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${tradeData.version} --> Release trade`);
            if (tradeData.version == types_1.Version.V0) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Old escrow config not found");
                }
                const tradeV0 = (0, utils_1.getTradeClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, tradeData);
                return tradeV0.release();
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeClientV1)((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, tradeData);
                return tradeCurrent.release();
            }
        });
    }
    callArbitrator(wallet, tradeData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tradeData.version == types_1.Version.V0) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Old escrow config not found");
                }
                const tradeV0 = (0, utils_1.getTradeClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, tradeData);
                return tradeV0.callArbitrator(wallet.publicKey);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeClientV1)((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, tradeData);
                return tradeCurrent.callArbitrator(wallet.publicKey);
            }
        });
    }
    resolveDispute(wallet, tradeData, disputeAction, compensationAction) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`Version: ${tradeData.version} --> Resolve dispute`);
            if (tradeData.version == types_1.Version.V0) {
                if (!this.fetcherV0 || !this.pubkeyV0 || !this.configIdV0) {
                    throw new Error("Old escrow config not found");
                }
                const tradeV0 = (0, utils_1.getTradeClientV0)((0, utils_1.getContextV0)(this.fetcherV0.connection, wallet, this.pubkeyV0), this.configIdV0, tradeData);
                return tradeV0.resolveDispute(wallet.publicKey, disputeAction, compensationAction);
            }
            else {
                const tradeCurrent = (0, utils_1.getTradeClientV1)((0, utils_1.getContextV1)(this.fetcherV1.connection, wallet, this.pubkeyV1), this.marketIdV1, this.configIdV1, tradeData);
                return tradeCurrent.resolveDispute(wallet.publicKey, disputeAction, compensationAction);
            }
        });
    }
}
exports.EscrowRouter = EscrowRouter;
